<div class="container-fluid">
  <form #f="ngForm" name="form" (ngSubmit)="f.form.valid && submitForm(productResult)" class="form-inline required" novalidate>
 <!--  <form #invoice="ngForm" (ngSubmit)="submitForm(items)" class="form-inline required" novalidate> -->
    <div *ngIf="!invc_editD" class="add">
      <div class="ModalHeader">
        <h2 mat-dialog-title>Add Invoice</h2>
        <div class="headerButton">
          <button class="btn btn-success" type="submit"><i aria-hidden="true"
          class="fa fa-floppy-o"></i> Save
          </button>
          <button (click)="close()" class="btn btn-warning" matDialogClose type="button"><i
            aria-hidden="true" class="fa fa-times"></i> Cancel
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-lg-4">
                <label for="Datepicker"> Invoice Date: </label>
                <input [(ngModel)]="headObj.datePick" class="form-control" name="date" readonly type="text" #date="ngModel" class="form-control" id="datePick" [ngClass]="{ 'is-invalid': f.submitted && date.invalid }" required>
              </div>
              <div class="form-group col-lg-4">
                <label class="labelRequired">Purchase Order Number: </label>
                <select (change)="selectedOrderFn($event)" [(ngModel)]="selectedOrder" class="form-control" data-show-content="true" name="purchase_order_id" id="selectedOrder" #purchase_order_id="ngModel" [ngClass]="{ 'is-invalid': f.submitted && purchase_order_id.invalid }" required>
                  <option selected>Select Purchase Order Number</option>
                  <option *ngFor="let loc of purchaseOrder" [value]="loc.id"> {{loc.id}} - {{loc.status}} </option>

                </select>
              </div>
            </div>
            <p class="MandRequired" style="color: red;margin-bottom: 0px">
              Please Enter Mandatory Field
            </p>
            <div class="row col-lg-12 col-md-12 col-sm-3">
              <div class="table-responsive">
                <table class="table table-responsive table-bordered invoiceTable ">
                  <thead>
                  <th class="col-xs-2 labelRequired" scope="col">Code</th>
                  <th scope="col">Product</th>
                  <th class="labelRequired" scope="col">Expiry Date</th>
                  <th class="labelRequired" scope="col">Batch No</th>
                  <th class="labelRequired" scope="col">Quantity</th>
                  <th (click)="calculate()" class="labelRequired" scope="col">Rate</th>
                  <th class="labelRequired" scope="col">Discount(%)<!-- / Amount --></th>
                  <th scope="col">Amount</th>
                  </thead>
                  <tbody>
                  <tr *ngFor="let row of items; let i=index ">
                    <td>
                      <div class="input-group">
                         <input type="text" size="10" class="form-control" [value]="row.code" name="{{'code'+i}}" #code="ngModel" id="{{'Code'+i}}" [(ngModel)]="row.code" required [ngClass]="{ 'is-invalid': f.submitted && code.invalid }">
                        <span class="input-group-btn iconsSize">
                        </span>
                      </div>
                    </td>
                    <td><input [value]="row.name" class="form-control" name="product_name" readonly requiredstyle="width: 100%" type="text"/></td>
                    <td style="display: flex;">
                       <input matInput [matDatepicker]="picker" readonly  class="form-control" name="expiry_date"
                       required size="3" #expiry_date="ngModel" [value]="row.expiry_date" [(ngModel)]="row.expiry_date" required [ngClass]="{ 'is-invalid': f.submitted && expiry_date.invalid }"type="text">
                      <mat-datepicker-toggle matSuffix [for]="picker">
                      <mat-datepicker #picker></mat-datepicker>
                      </mat-datepicker-toggle>
                    </td>
                    <td>
                      <input #inputstring (keyup)="row.batch_no=inputstring.value;" [value]="row.batch_no" class="form-control" name="batch_no"#batch_no="ngModel" [value]="row.batch_no" [(ngModel)]="row.batch_no" required [ngClass]="{ 'is-invalid': f.submitted && batch_no.invalid }"
                             required size="5"/>
                    </td>
                    <td>
                      <select (change)="quantityChange($event, 'quantity',i)" [value]="row.pending_quantity" class="form-control"
                              data-show-content="true" name="{{'quantity'+i}}" #quantity="ngModel" [value]="row.quantity" [(ngModel)]="row.quantity" required [ngClass]="{ 'is-invalid': f.submitted && quantity.invalid }"required>
                        <option *ngFor="let item of [].constructor(row.pending_quantity+1); let j = index"
                                [value]="j"> {{j}} </option>

                      </select>
                    </td>
                    <td><input (blur)="prizeChange($event, 'amount',i)" [value]="row.amount" class="form-control" name="{{'amount'+i}}" size="5" #amount="ngModel" [(ngModel)]="row.amount" required [ngClass]="{ 'is-invalid': f.submitted && amount.invalid }"
                               type="text"/></td>
                    <td>
                      <input (blur)="discountChange($event, 'discount',i)" [value]="row.discount" class="form-control" size="2"name="{{'discount'+i}}" size="5" #discount="ngModel" [(ngModel)]="row.discount" required [ngClass]="{ 'is-invalid': f.submitted && discount.invalid }"style="width: 50% !important;" type="text"/>
                      <span *ngIf="this.items[i].discount > '0' && showDiscount"> / {{ (this.items[i].amount * this.items[i].quantity) - this.items[i].rate | number }}</span>
                    </td>
                    <td>
                      <div class="input-group">
                        <input [value]="row.rate" class="form-control" name="indexamount" size="10" type="text"  />
                        <span class="input-group-btn cancelIcon">
                            <button class="btn btn-default" type="button">
                                <i (click)="deleteRow(i)" aria-hidden="true"
                                   class="fa fa-times" style="color: red"></i>
                            </button>
                        </span>
                      </div>

                    </td>
                  </tr>
                  <tr>
                    <td colspan="5" rowspan="4">
                      &nbsp;
                    </td>
                    <td colspan="2"> Grand Total</td>
                    <td>
                      <div class="input-group">
                        <input [value]="totals.gT" class="form-control" name="grant_ttl" readonly size="10"
                               type="text"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">Total Discount</td>
                    <td>
                      <div class="input-group">
                        <input [value]="totals.d" class="form-control" readonly size="10"
                               type="text"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2"> Net total</td>
                    <td>
                      <div class="input-group">
                        <input [value]="totals.nT" class="form-control" name="net_total" readonly size="10"
                               type="text"/>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </mat-dialog-content>
    </div>

    <div *ngIf="invc_editD" class="edit">
      <div class="ModalHeader">
        <h2 mat-dialog-title>Invoice Details</h2>
        <div class="headerButton">
          <button (click)="close()" class="btn btn-warning" matDialogClose type="button"><i
            aria-hidden="true" class="fa fa-times"></i> Cancel
          </button>
        </div>
      </div>

      <mat-dialog-content>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-lg-4">
                <span> Date: {{invc_editD.invoice.date | date:'dd/MM/yyyy'}}</span>
              </div>
              <!--<div class="form-group col-lg-4">
                <span>Purchase Order Number: {{invc_editD.invoice.purchase_no}}</span>
              </div> -->
              <div class="form-group col-lg-4">
                <span>SI Number: {{invc_editD.invoice.id}}</span>
              </div>

            </div>
            <div class="row col-lg-12 col-md-12 col-sm-3">
              <div class="table-responsive">
                <table class="table table-responsive table-bordered invoiceTable ">
                  <thead>
                  <th scope="col">Code</th>
                  <th scope="col">Product</th>
                  <th scope="col">Expiry Date</th>
                  <th scope="col">Batch No</th>
                  <th scope="col">Quantity</th>
                  <!-- <th scope="col">Rate</th>
                  <th scope="col">Discount(%)</th>
                  <th scope="col">Amount</th> -->
                  <th scope="col">Action</th>
                  </thead>
                  <tbody>
                  <tr *ngFor="let row of invc_editD_Pro; let i=index ">
                    <td>{{row.code}}</td>
                    <td>{{row.product_name}}</td>
                    <td>{{row.expire_date | date:'dd/MM/yyyy'}}</td>
                    <td>{{row.batch_no}}</td>
                    <td>{{row.quantity}}</td>
                    <!--<td>{{row.amount}}</td>
                    <td>{{row.discount}}</td>
                    <td>{{row.rate}}</td> -->
                    <td>
                      <div *ngIf="row.is_printed == '0' && editPermission" class="input-group">
                        <span class="input-group-btn cancelIcon">
                            <button class="btn btn-default" type="button">
                                <i (click)="confirmationModal(i, row)" aria-hidden="true"
                                   class="fa fa-print"></i>

                            </button>
                        </span>
                      </div>
                    </td>
                  </tr>
                  <!--<tr>
                    <td colspan="5" rowspan="4">
                    </td>
                    <td colspan="2"> Grand Total</td>
                    <td>{{editTotal.gt}}</td>
                  </tr>
                  <tr>
                    <td colspan="2"> Discount Total</td>
                    <td>{{editTotal.d}}</td>
                  </tr>

                  <tr>
                    <td colspan="2"> Net total</td>
                    <td>{{editTotal.nt}}</td>
                  </tr> -->
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </mat-dialog-content>
    </div>
  </form>
</div>
